const BuildingEquipments = [
  {
    name: '構造',
    checkbox: [
      { label: '建設住宅性能評価付', value: 'f_construction_performance' },
      { label: '設計住宅性能評価付', value: 'f_design_performance' },
      { label: '長期優良住宅', value: 'f_longlife' },
      { label: '制震', value: 'f_seismic_control' },
      { label: '免震', value: 'f_seismic_isolation' },
      { label: '耐震', value: 'f_seismic_resistance' },
      { label: 'インスペクション済', value: 'f_inspection' },
      { label: '耐震適合', value: 'f_seismic_compatible' },
      { label: '外壁サイディング', value: 'f_outer_wall_siding' },
      { label: '外壁タイル張り', value: 'f_outer_wall_tile' },
      { label: '側溝', value: 'f_gutter' },
      { label: '省エネルギー対策', value: 'f_energy_saving_measures' },
      { label: '高気密高断熱', value: 'f_high_insulation' },
      { label: '複層ガラス', value: 'f_double_glass' },
      { label: '太陽光発電', value: 'f_solar_power' },
      { label: 'ノンホルムアルデヒド', value: 'f_non_formaldehyde' },
      { label: 'エレベーター', value: 'f_elevator' },
    ],
  },
  {
    name: '通信',
    checkbox: [
      { label: '高速インターネット', value: 'f_high_speed_internet' },
      { label: 'BS', value: 'f_bs' },
      { label: 'CS', value: 'f_cs' },
      { label: 'CATV', value: 'f_catv' },
      { label: '有線', value: 'f_usen' },
    ],
  },
  {
    name: 'セキュリティ',
    checkbox: [
      { label: 'セキュリティ充実', value: 'f_enhanced_security' },
      { label: 'モニタ付オートロック', value: 'f_monitor_auto_lock' },
      { label: 'オートロック', value: 'f_auto_lock' },
      { label: '宅配ボックス', value: 'f_delivery_box' },
      { label: '24時間セキュリティ', value: 'f_24h_security' },
    ],
  },
  {
    name: '共用部',
    checkbox: [
      { label: '共用設備充実', value: 'f_share_enrichment' },
      { label: '24時間ごみ出し可', value: 'f_24h_garbage' },
      { label: 'フィットネスジム', value: 'f_fitness_gym' },
      { label: 'プール', value: 'f_pool' },
      { label: 'キッズルーム・託児所', value: 'f_kids_room' },
      { label: '大浴場', value: 'f_big_bath' },
      { label: 'コインランドリー', value: 'f_coin_laundry' },
      { label: 'コンシェルジュサービス', value: 'f_concierge' },
      { label: '共同トイレ', value: 'f_share_toilet' },
      { label: 'バイク置き場', value: 'f_bike_space' },
      { label: '自転車置き場', value: 'f_bicycle_space' },
    ],
  },
  {
    name: 'その他特徴',
    checkbox: [
      { label: 'デザイナーズ', value: 'f_designers' },
      { label: '畑付', value: 'f_hatake' },
      { label: '古民家風', value: 'f_kominka' },
      { label: 'ログハウス', value: 'f_log_house' },
      { label: '輸入住宅', value: 'f_import_house' },
    ],
  },
]

export default BuildingEquipments
